module.exports = __webpack_public_path__ + "static/media/benacq-2.70cb1523.jpg";